import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=4454c07a&scoped=true"
import script from "./feature.vue?vue&type=script&lang=ts"
export * from "./feature.vue?vue&type=script&lang=ts"
import style0 from "./feature.vue?vue&type=style&index=0&id=4454c07a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454c07a",
  null
  
)

export default component.exports